import React, { useCallback, useMemo } from 'react'
import { Checkbox } from 'antd'
import { find, includes, isNil } from 'lodash'
import PropTypes from 'prop-types'

const PriorityTaskAllocationActionCell = ({
  menuCurationTask,
  priorityTaskId,
  selectedAllocationIds,
  onSelectionChange,
}) => {
  const currentAllocation = useMemo(
    () =>
      find(
        menuCurationTask.priorityTaskAllocations,
        allocation => allocation.priorityTask?.id === priorityTaskId,
      ),
    [menuCurationTask.priorityTaskAllocations, priorityTaskId],
  )

  const isSelected = useMemo(
    () => includes(selectedAllocationIds, currentAllocation?.id),
    [selectedAllocationIds, currentAllocation?.id],
  )

  const handleCheckboxChange = useCallback(
    e => {
      if (e.target.checked) {
        onSelectionChange([...selectedAllocationIds, currentAllocation.id])
      } else {
        onSelectionChange(
          selectedAllocationIds.filter(id => id !== currentAllocation.id),
        )
      }
    },
    [currentAllocation?.id, selectedAllocationIds, onSelectionChange],
  )

  if (isNil(currentAllocation)) {
    return null
  }

  return <Checkbox checked={isSelected} onChange={handleCheckboxChange} />
}

PriorityTaskAllocationActionCell.propTypes = {
  menuCurationTask: PropTypes.object.isRequired,
  priorityTaskId: PropTypes.string.isRequired,
  selectedAllocationIds: PropTypes.array.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
}

export default PriorityTaskAllocationActionCell
